export default ({ store }) => {
  store.dispatch('appointmentForm/loadFromLocalStorage');
};
